import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import "../css/ClientFilters.css";

export default function ClientFilters({ value, onChange, onApply, onReset }) {
  const [options, setOptions] = useState({
    clientNames: [],
    industries: [],
    businessSegments: [],
  });
  const [loading, setLoading] = useState(true);

  // Load dropdown options (existing values from the database) once on mount
  useEffect(() => {
    api
      .get("/client/filter-options")
      .then((res) =>
        setOptions({
          clientNames: res.data.clientNames || [],
          industries: res.data.industries || [],
          businessSegments: res.data.businessSegments || [],
        })
      )
      .catch((err) => console.error("Failed to load filter options", err))
      .finally(() => setLoading(false));
  }, []);

  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });

  // Reset is only useful when at least one filter has a value.
  const hasAnyFilter = ["name", "industry", "businessSegment", "startDate", "endDate"].some((k) => value[k]);

  const dropdown = (key, id, list) => (
    <select
      id={id}
      className={`cf-control${value[key] ? " is-set" : ""}`}
      value={value[key] || ""}
      onChange={set(key)}
      disabled={loading}
    >
      <option value="">{loading ? "Loading…" : "All"}</option>
      {list.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  );

  return (
    <div className="cf-bar">
      <div className="cf-grid">
        <div className="cf-field">
          <label htmlFor="cf-name">Name</label>
          {dropdown("name", "cf-name", options.clientNames)}
        </div>

        <div className="cf-field">
          <label htmlFor="cf-industry">Industry</label>
          {dropdown("industry", "cf-industry", options.industries)}
        </div>

        <div className="cf-field">
          <label htmlFor="cf-segment">Business segment</label>
          {dropdown("businessSegment", "cf-segment", options.businessSegments)}
        </div>

        <div className="cf-field">
          <label htmlFor="cf-from">Added from</label>
          <input
            id="cf-from"
            type="date"
            className={`cf-control${value.startDate ? " is-set" : ""}`}
            value={value.startDate || ""}
            max={value.endDate || undefined}
            onChange={set("startDate")}
          />
        </div>

        <div className="cf-field">
          <label htmlFor="cf-to">Added to</label>
          <input
            id="cf-to"
            type="date"
            className={`cf-control${value.endDate ? " is-set" : ""}`}
            value={value.endDate || ""}
            min={value.startDate || undefined}
            onChange={set("endDate")}
          />
        </div>

        <div className="cf-actions">
          <button type="button" className="cf-btn cf-btn-secondary" onClick={onReset} disabled={!hasAnyFilter}>
            Reset
          </button>
          <button type="button" className="cf-btn cf-btn-primary" onClick={onApply}>
            Apply filters
          </button>
        </div>
      </div>
    </div>
  );
}
